import EntityChallengesTimerFormat from './EntityChallengesTimerForm';

export default EntityChallengesTimerFormat;
